module.exports = __webpack_public_path__ + "img/d.e83d412c.jpg";